import Vue from 'vue'
import VueRouter from 'vue-router'
import Layout from '@/layout/index.vue'

Vue.use(VueRouter)

// 静态路由：只保留登录、404和基础Layout
// 末尾追加的「静态后备路由」用于在 permission.js 动态路由从后端拉菜单失败时仍可访问关键页面
// 既不接管动态路由机制，也不破坏既有 login / 根路径 / 404 三条静态路由
export const constantRoutes = [
    {
        path: '/login',
        component: () => import('@/views/login/index.vue'),
        hidden: true
    },
    {
        path: '/',
        component: Layout,
        hidden: true
    },

    {
        path: '/404',
        component: () => import('@/views/error/404.vue'),
        hidden: true
    },

    // ========== 静态后备路由（开发联调与菜单种子未执行时的兜底入口） ==========
    // 设计目的：动态路由机制（permission.js + GenerateRoutes）依赖后端 sys_menus 数据；
    // 当菜单种子 SQL 尚未执行或后端拉菜单接口异常时，下列 URL 仍可直接访问：
    //   /app/task        任务工单
    //   /app/task-audit  任务审核
    //   /app/withdraw    提现审核
    //   /system/log/page 操作日志（高级）
    // 这里只是「兜底可达」，菜单显隐与权限控制仍由后端动态路由主导，互不冲突
    {
        // 静态兜底：hidden=true 保证不在侧边栏出现，避免与后端动态菜单 (sys_menus id=100~108) 重复渲染
        // 仍保留路由注册：菜单种子 SQL 未执行 / 动态菜单接口异常时，仍可通过 URL 直达页面
        path: '/app',
        component: Layout,
        hidden: true,
        children: [
            {
                // 任务工单：分页 + 详情 + 强制关闭
                path: 'task',
                component: () => import('@/views/app/task/index.vue'),
                meta: { title: '任务工单', icon: 'profile' }
            },
            {
                // 任务审核：审核通过 / 审核拒绝
                path: 'task-audit',
                component: () => import('@/views/app/task-audit/index.vue'),
                meta: { title: '任务审核', icon: 'check-circle' }
            },
            {
                // 提现审核:审核通过 / 审核拒绝 / 详情
                path: 'withdraw',
                component: () => import('@/views/app/withdraw/index.vue'),
                meta: { title: '提现审核', icon: 'wallet' }
            },
            // ===== master-profile-extension 兜底路由 =====
            {
                // 服务技能 - 大类维护
                path: 'skill-category',
                component: () => import('@/views/app/skill-category/index.vue'),
                meta: { title: '服务技能 - 大类', icon: 'apartment' }
            },
            {
                // 服务技能 - 子项维护
                path: 'skill-item',
                component: () => import('@/views/app/skill-item/index.vue'),
                meta: { title: '服务技能 - 子项', icon: 'tags' }
            },
            {
                // 证书种类维护
                path: 'cert-type',
                component: () => import('@/views/app/cert-type/index.vue'),
                meta: { title: '证书种类维护', icon: 'safety-certificate' }
            },
            {
                // 车辆种类维护
                path: 'vehicle-type',
                component: () => import('@/views/app/vehicle-type/index.vue'),
                meta: { title: '车辆种类维护', icon: 'car' }
            },
            {
                // 证书审核
                path: 'cert-audit',
                component: () => import('@/views/app/cert-audit/index.vue'),
                meta: { title: '证书审核', icon: 'audit' }
            },
            {
                // 车辆审核
                path: 'vehicle-audit',
                component: () => import('@/views/app/vehicle-audit/index.vue'),
                meta: { title: '车辆审核', icon: 'check-square' }
            },
            // ===== bidding-task-platform 任务 29.5 兜底路由：服务类目 / 商品库 =====
            {
                // 服务类目维护：动态路由失败时通过 URL 直达
                path: 'service-category',
                component: () => import('@/views/app/service-category'),
                meta: { title: '服务类目', icon: 'cluster' }
            },
            {
                // 商品库维护：动态路由失败时通过 URL 直达
                path: 'service-product',
                component: () => import('@/views/app/service-product'),
                meta: { title: '商品库', icon: 'shop' }
            }
        ]
    },
    {
        // 操作日志（高级查询）兜底入口；hidden=true 表示不出现在侧边栏，仅可通过 URL 访问
        path: '/system',
        component: Layout,
        hidden: true,
        children: [
            {
                path: 'log/page',
                component: () => import('@/views/system/log/index.vue'),
                meta: { title: '操作日志(高级)', icon: 'file-text' }
            }
        ]
    }
]

const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes: constantRoutes
})

export default router
